import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "product-box__segment-header" }
const _hoisted_2 = {
  key: 0,
  class: "product-box__highlight-article-badge"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product-box__header-container" }
const _hoisted_6 = { class: "product-box__name" }
const _hoisted_7 = {
  key: 0,
  class: "product-box__bottle-amount"
}
const _hoisted_8 = {
  key: 1,
  class: "product-box__vintage"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href", "target"]
const _hoisted_12 = ["aria-label"]

import {computed, inject} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import jsGlobalConfig from '../../../bps/globals/jsGlobalConfig';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxSegmentHeader',
  props: {
    productBoxData: {},
    state: {},
    numberOfBottlesInSet: { default: null },
    productLink: { default: '' },
    showReview: { type: Boolean, default: false },
    showInBasket: { type: Boolean, default: false },
    isWishlistEnabled: { type: Boolean, default: true }
  },
  emits: ['wishlistClicked'],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const basketUrl = jsGlobalConfig().getBasketUrl();
  const linkTarget = inject('productBoxLinkTarget', null);

  const productShortDescription = computed(() => {
    if (props.productBoxData.description2 && props.productBoxData.shortDescription) {
      return `${props.productBoxData.description2}, ${props.productBoxData.shortDescription}`;
    }
    return props.productBoxData.description2 || props.productBoxData.shortDescription;
  });


  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

  const highlightBadgeData = computed(() => {
    const textSpacer = '&nbsp;&nbsp;';

    if (highlightArticleData.value) {
      const articleHighlight = highlightArticleData.value;
      articleHighlight.text += textSpacer;
      return articleHighlight;
    }

    if (props.productBoxData.personalPreferenceMessageKey) {
      return {
        style: {},
        text: t(props.productBoxData.personalPreferenceMessageKey) + textSpacer,
        icon: null
      };
    }

    return null;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (highlightBadgeData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (highlightBadgeData.value.text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: highlightBadgeData.value.text,
                class: "product-box__highlight-article-text"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (highlightBadgeData.value.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "product-box__highlight-article-icon",
                src: highlightBadgeData.value.icon,
                alt: "",
                width: "20",
                height: "20",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productLink ? 'a' : 'div'), {
        href: _ctx.productLink,
        target: _ctx.productLink ? _unref(linkTarget) : null,
        class: _normalizeClass(["product-box__header-text", {
          'product-box__header-text--with-vintage': _ctx.productBoxData.vintage
        }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, [
            (_ctx.numberOfBottlesInSet)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.numberOfBottlesInSet) + " x\n          ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _cache[2] || (_cache[2] = _createTextVNode()),
            (_ctx.productBoxData.vintage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.productBoxData.vintage), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(_ctx.productBoxData.description1), 1 /* TEXT */)
          ]),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (_ctx.productBoxData.description2 || _ctx.productBoxData.shortDescription)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "product-box__short-description",
                innerHTML: productShortDescription.value
              }, null, 8 /* PROPS */, _hoisted_9))
            : _createCommentVNode("v-if", true),
          _cache[4] || (_cache[4] = _createTextVNode()),
          (_ctx.showInBasket && _ctx.productBoxData.inBasket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("a", {
                  class: "product-box__status product-box__status--basket product-box__status--basket-up",
                  href: _unref(basketUrl),
                  target: _unref(linkTarget)
                }, _toDisplayString(_unref(t)('ads.ads_top_info.article_in_basket')), 9 /* TEXT, PROPS */, _hoisted_11)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href", "target", "class"])),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (!_ctx.productBoxData.zeroPriceItem && _ctx.productBoxData.valid && !_ctx.productBoxData.recurringOrderFollowUpPacket)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["product-box__button-wishlist", {
          'product-box__button-wishlist--filled': _ctx.isWishlistEnabled && _ctx.productBoxData.inWishlist && _ctx.state !== 'loadingWishlist',
          'product-box__button-wishlist--remove': !_ctx.isWishlistEnabled,
          'product-box__button-wishlist--loading': _ctx.state === 'loadingWishlist',
        }]),
            "aria-label": _unref(t)('wishlist.default.name'),
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('wishlistClicked')), ["prevent"]))
          }, null, 10 /* CLASS, PROPS */, _hoisted_12))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})